export const config = {
  autoSave: false,
  autoResolveConflicts: false,
};
